import { useTranslation } from "react-i18next";

import { dropdownMenuColumn, timestampColumn } from "../../ui/utils/columns";

import useDistributionChannelDropdownMenuOptions from "./useDistributionChannelDropdownMenuOptions";

export default function useDistributionChannelsTableColumns() {
	const { t } = useTranslation();

	return [
		{
			id: "name",
			filter: "text",
			disableSortBy: true,
			Header: t("Name", "Name"),
		},
		timestampColumn({
			id: "created",
			Header: t("created", "Created"),
		}),
		dropdownMenuColumn(useDistributionChannelDropdownMenuOptions),
	];
}
